import { ShareCartPayload } from '@cart/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomCartState, StateWithCustomCart } from '../cart-state';
import { getCustomCartState } from './feature.selector';

export const getShareCartState: MemoizedSelector<
  StateWithCustomCart,
  StateUtils.LoaderState<ShareCartPayload>
> = createSelector(getCustomCartState, (state: CustomCartState) => state.shareCart);

export const getShareCartValue: MemoizedSelector<StateWithCustomCart, ShareCartPayload> = createSelector(
  getShareCartState,
  (state: StateUtils.LoaderState<ShareCartPayload>) => StateUtils.loaderValueSelector(state),
);

export const getShareCartLoading: MemoizedSelector<StateWithCustomCart, boolean> = createSelector(
  getShareCartState,
  (state: StateUtils.LoaderState<ShareCartPayload>) => StateUtils.loaderLoadingSelector(state),
);

export const getShareCartError: MemoizedSelector<StateWithCustomCart, boolean> = createSelector(
  getShareCartState,
  (state: StateUtils.LoaderState<ShareCartPayload>) => StateUtils.loaderErrorSelector(state),
);

export const getShareCartSuccess: MemoizedSelector<StateWithCustomCart, boolean> = createSelector(
  getShareCartState,
  (state: StateUtils.LoaderState<ShareCartPayload>) => StateUtils.loaderSuccessSelector(state),
);
